<template>
  <ProviderRequests />
</template>

<script>
import ProviderRequests from "@/sections/lookupengine/components/Statistics/ProviderRequests.vue";

export default {
  name: "ProviderRequestsView",
  components: {
    ProviderRequests,
  },
};
</script>
